<template>
  <div v-if="blok.display_popin" class="sticky-information__spacer" aria-hidden="true"></div>
  <div v-if="blok.display_popin" v-editable="blok" class="sticky-information" :class="{ 'modal-open': isModalOpen }">

    <div class="sticky-information__cta-wrapper">
      <SimpleButton :solid="true" @click="openModal">
        {{ blok.cta_label }}
      </SimpleButton>
    </div>

    <GenericModal ref="stickyModal" css-class="stickyInformationModal" height-auto @close="onCloseModal">
      <div class="sticky-information__content">
        <div v-if="blok.title" class="sticky-information__title">
          {{ blok.title }}
        </div>

        <div v-if="blok.description" class="sticky-information__description">
          {{ blok.description }}
        </div>

        <div v-if="blok.button && blok.button.length > 0" class="sticky-information__button">
          <SimpleButton xl
            v-for="btn in blok.button"
            :key="btn._uid"
            :link="btn.link"
            :solid="btn.Style === 'solid'"
            :outlined="btn.Style === 'outlined'"
            :light="btn.Style === 'light'"
            :flat="btn.Style === 'flat'"
          >
            <SvgIcon v-if="btn.iconName && btn.iconName !== ''" :name="`func_${btn.iconName}`" />
            <span class="button-text">{{ btn.title }}</span>
          </SimpleButton>
        </div>

        <div v-if="blok.contact_items && blok.contact_items.length > 0" class="sticky-information__contacts">
          <SimpleButton xl
            v-for="item in blok.contact_items"
            :key="item._uid"
            :link="item.link"
            :solid="item.Style === 'solid'"
            :outlined="item.Style === 'outlined'"
            :light="item.Style === 'light'"
            :flat="item.Style === 'flat'"
            @click="handleContactClick(item)"
          >
            <SvgIcon v-if="item.iconName && item.iconName !== ''" :name="`func_${item.iconName}`" />
            <div class="button-text-wrapper">
              <span class="button-text">{{ item.title }}</span>
              <span v-if="item.subtitle" class="subtitle">{{ item.subtitle }}</span>
            </div>
          </SimpleButton>
        </div>
      </div>
    </GenericModal>
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'

const openCallbackModal = inject("callback", () => {});
const openVisitModal = inject("facility-visit", () => {});
const trackingStore = useTrackingStore();

const props = defineProps({
  blok: {
    type: Object,
    required: true
  }
})

const stickyModal = ref(null)
const isModalOpen = ref(false)

const openModal = () => {
  isModalOpen.value = true
  stickyModal.value && stickyModal.value.openModal()
}

const onCloseModal = () => {
  isModalOpen.value = false
}

const handleContactClick = (item) => {
  switch (item.request_type) {
    case "callback":
      trackingStore.sendTrackingData({
        event: 'click.action',
        click: 'callback',
        click_chapter1: 'sticky_information',
        click_chapter2: 'CTA',
        form_name: getInquiryFormName('callback'),
      });
      openCallbackModal();
      break;
    case "visit":
      trackingStore.sendTrackingData({
        event: 'click.action',
        click: 'visit',
        click_chapter1: 'sticky_information',
        click_chapter2: 'CTA',
        form_name: getInquiryFormName('visit'),
      });
      openVisitModal();
      break;
    default:
      console.log("Unknown contact item clicked", item);
      break;
  }
};
</script>

<style lang="scss" scoped>
.sticky-information__spacer {
  height: calc(0.5rem + 2.5rem + 0.5rem + 1rem);

  @include for-tablet-landscape-up {
    display: none;
  }
}

.sticky-information {
  position: fixed;
  padding: 0.5rem;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $z-index-fixed;

  @include for-tablet-landscape-up {
    display: none;
  }

  &.modal-open {
    display: none;
  }

  body.no-scroll & {
    display: none;
  }

  &__cta-wrapper {
    display: flex;
    justify-content: center;

    .simple-button {
      width: 100%;
    }
  }

  &__content {
    width: 100%;
    text-align: center;
  }

  &__title {
    font-size: 1.375rem;
    line-height: 105%;
    font-weight: 700;
    margin-bottom: 1rem;
    color: var(--text-100);
  }

  &__description {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 140%; 
    color: var(--text-100);
    margin-bottom: 2.5rem;

    :deep(p) {
      margin-bottom: 0.5rem;
    }
  }

  &__button {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.625rem;
    margin-bottom: 0.625rem;

    .simple-button {
      width: 100%;
      border-radius: 1.25rem !important;
      flex-direction: row;
      padding: 1rem 0.5rem;

      :deep(.icon) {
        margin-right: 1rem;
      }
    }
  }

  &__contacts {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.625rem;

    .simple-button {
      width: 100%;
      border-radius: 1.25rem !important;
      flex-direction: row;
      padding: 1rem 0.5rem;

      :deep(.icon) {
        margin-right: 1rem;
      }
    }
  }
}

.button-text-wrapper {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.button-text {
  text-align: center;
  font-size: 1rem !important;
}

.subtitle {
  display: block;
  font-size: 0.75rem;
  font-weight: 400;
  opacity: 0.8;
  text-align: center;
}
</style>

<style lang="scss">
.stickyInformationModal {
  .modal-inner {
    padding-bottom: 0;
  }
}
</style>
